import React, { useState } from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { getProjectShortTitle } from "entities/projects/lib/getProjectShortTitle"
import { useProjectColor } from "entities/projects/model/useProjectColor"

import "./styles/_project-option.scss"

interface ProjectOptionProps extends WithClassName {
  color: string
  title: string
  isTeamProject?: boolean
  useShortTitle?: boolean
}

export const ProjectOption = React.memo(
  ({
    color,
    title,
    useShortTitle,
    isTeamProject,
    className
  }: ProjectOptionProps) => {
    const [colorElement, setColorElement] = useState<HTMLElement | null>(null)
    useProjectColor({ element: colorElement, color })

    return (
      <div className={classNames("project-option", className)}>
        <div
          className="project-option__color-circle project-gradient"
          ref={setColorElement}
        />
        <div className="project-option__title">
          {useShortTitle ? getProjectShortTitle(title) : title}
        </div>
        {isTeamProject ? (
          <Icon
            name={IconName.TEAM}
            className="project-option__team-indicator"
          />
        ) : null}
      </div>
    )
  }
)
